module.exports = __webpack_public_path__ + "static/media/news4.d89e0404.jpg";